// src/data/publicityData.js
export const newsData = [
  {
    title: "荣誉证书领取",
    date: "2025-07-10",
    link: "/publicity/certificate"
  }
];

export const activities = [
  {
    title: "MC服务器上线",
    date: "2024-04-20",
    image: "https://pic6.zhimg.com/80/v2-e7a35d536823255c4c5664a528d6a9ef_1440w.jpeg",
    link: "https://mc.ecustcic.com/Gallery/%E6%96%87%E9%87%8E%E3%81%AE%E6%97%85%E7%A8%8B.html"
  }
];